import { cn } from '@/lib/utils';
import { formatDateTime } from '@/utils/format-date';
import type { ScheduledRun } from '@/types/schedules';

interface RunCardProps {
  run: ScheduledRun;
  selected: boolean;
  onSelect: () => void;
}

export function RunCard({ run, selected, onSelect }: RunCardProps) {
  const timestamp = run.started_at ?? run.created_at;
  const needsAttention = run.error_count > 0 || run.status === 'failed';

  return (
    <button
      type='button'
      onClick={onSelect}
      className={cn(
        'flex w-full flex-col gap-3 rounded-lg p-4 text-left transition-colors hover:bg-accent/60',
        selected && 'bg-accent hover:bg-accent',
      )}
    >
      <div className='space-y-1'>
        <div className='flex items-center gap-2'>
          <p className='truncate text-sm text-muted-foreground'>
            {run.workflow_name}
          </p>
          {needsAttention && (
            <span className='size-2 shrink-0 rounded-full bg-red-500' />
          )}
        </div>
        {run.outcome_summary && (
          <p className='line-clamp-3 text-base leading-6 text-foreground'>
            {run.outcome_summary}
          </p>
        )}
      </div>
      <div className='flex items-center gap-3 text-sm text-muted-foreground'>
        {run.schedule_name && (
          <>
            <span className='truncate'>{run.schedule_name}</span>
            <span className='size-0.5 shrink-0 rounded-full bg-muted-foreground' />
          </>
        )}
        {timestamp && (
          <span className='shrink-0'>{formatDateTime(timestamp)}</span>
        )}
      </div>
    </button>
  );
}
